import { Room, Visit } from "@cur8/rich-entity";

export const UNASSIGNED_ROOM_LABEL = "Unassigned";
export const UNASSIGNED_ROOM_ID = "unassigned";

export interface VisitRoomGroup {
  // Unique per group (roomId, or the Unassigned sentinel) so the list key
  // survives two rooms sharing a display name.
  id: string;
  label: string;
  visits: Visit[];
}

export function groupVisitsByRoom(
  visits: Visit[],
  rooms: Room[]
): VisitRoomGroup[] {
  const roomsById = new Map(rooms.map((room) => [room.id, room]));
  const groupsByRoomId = new Map<string, VisitRoomGroup>();
  const unassigned: Visit[] = [];

  for (const visit of visits) {
    const room = visit.roomId != null ? roomsById.get(visit.roomId) : undefined;
    // No resolvable room, or a room with no display name: both fall into the
    // single Unassigned bucket.
    if (room?.displayName == null) {
      unassigned.push(visit);
      continue;
    }
    const group = groupsByRoomId.get(room.id) ?? {
      id: room.id,
      label: room.displayName,
      visits: [],
    };
    group.visits.push(visit);
    groupsByRoomId.set(room.id, group);
  }

  const groups = Array.from(groupsByRoomId.values()).sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { numeric: true })
  );

  if (unassigned.length > 0) {
    groups.push({
      id: UNASSIGNED_ROOM_ID,
      label: UNASSIGNED_ROOM_LABEL,
      visits: unassigned,
    });
  }

  return groups;
}
